import $ from "jquery";
import { AosModule } from "./App/AosModule";
import { MenuModule } from "./App/MenuModule";
import { VideoModule } from "./App/VideoModule";
import { HeroVideoModule } from "./App/HeroVideoModule";
import { CountryInfoModule } from "./App/CountryInfoModule";
import { LinkActionsModule } from "./App/LinkActionsModule";
import InteractiveForm from "./App/Forms/InteractiveForm";
import PostListModule from "./App/PostListModule";
import CookieNotice from "./App/CookieNotice";
import constants from "./App/constants";
import CookieConsent from "./App/CookieConsent";

const menuModule = new MenuModule();
const videoModule = new VideoModule();
const heroVideoModule = new HeroVideoModule();
const countryInfoModule = new CountryInfoModule();
const postListModule = new PostListModule();
const aosModule = new AosModule();
const linkActionsModule = new LinkActionsModule();
const cookieNoticeHandler = new CookieNotice();

document.addEventListener("DOMContentLoaded", () => {
    menuModule.init();
    cookieNoticeHandler.refreshNotice();
    CookieConsent.init();

    new InteractiveForm();
});

$(document).on("keydown", function(event) {
    if (event.keyCode === constants.ESC_KEYCODE) {
        if (menuModule.menuIsOpen()) {
            menuModule.closeMenu(true);
        }
    }
});



// WEBPACK FOOTER //
// ./assets/scripts/front/index.js